import store from "@/store";

export function isTechnicianIso() {
  return ["iso-mobile", "iso-fissa", "iso-progettazione", "iso-preparazione"].includes(
    store.state.mainRole.team.name
  );
}
